import KC_Colors from "./KC_Colors";

export enum KC_Sizes {
  // seperator
  "sm",
  "m",
  "reg",
  "l",
  "xl",
  "default"
}

export enum KC_Text_Sizes {
  "md" = "md",
  "lg" = "lg"
}

export enum KC_Weights {
  "md" = "md",
  "bold" = "bold",
  "reg" = "reg"
}

export function classNameForColor(color?: KC_Colors) {
  switch (color) {
    case KC_Colors.Red:
      return "kc-red";
    case KC_Colors.Blue:
      return "kc-blue";
    case KC_Colors.Green:
      return "kc-green";
    case KC_Colors.Grey:
      return "kc-grey";
    case KC_Colors.LightGrey:
      return "kc-light-grey";
    case KC_Colors.Black:
      return "kc-black";
    case KC_Colors.Green_two:
      return "kc-green-two";
    case KC_Colors.Error:
      return "kc-error";
    default:
      return "kc-black";
  }
}

export function getHeight(
  size: KC_Sizes,
  sizeMap: Map<KC_Sizes, number>
): number | undefined {
  return sizeMap.get(size) || sizeMap.get(KC_Sizes.default);
}
